import { render, staticRenderFns } from "./post.vue?vue&type=template&id=0b4f20fd&scoped=true&"
import script from "./post.vue?vue&type=script&lang=js&"
export * from "./post.vue?vue&type=script&lang=js&"
import style0 from "./post.vue?vue&type=style&index=0&id=0b4f20fd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4f20fd",
  null
  
)

export default component.exports